import React from 'react';
import { Box, Calculator, Database, FileText } from 'lucide-react';

const Recursos: React.FC = () => {
    return (
        <div className="min-h-screen bg-[#f6f7f8] dark:bg-[#101922] font-sans py-20 px-6">
            <div className="max-w-7xl mx-auto">
                <h1 className="text-4xl font-bold text-slate-800 dark:text-white mb-8 text-center">Recursos</h1>
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    <div className="flex flex-1 flex-col gap-4 rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 p-6">
                        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-[#137fec]/10 text-[#137fec]">
                            <Box className="text-3xl" />
                        </div>
                        <div className="flex flex-col gap-1">
                            <h3 className="text-lg font-bold text-slate-800 dark:text-white">Integração com Modelos BIM</h3>
                            <p className="text-sm text-slate-600 dark:text-slate-400">Importe e analise seus modelos BIM para extração precisa de dados.</p>
                        </div>
                    </div>
                    <div className="flex flex-1 flex-col gap-4 rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 p-6">
                        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-[#137fec]/10 text-[#137fec]">
                            <Calculator className="text-3xl" />
                        </div>
                        <div className="flex flex-col gap-1">
                            <h3 className="text-lg font-bold text-slate-800 dark:text-white">Levantamento Automatizado</h3>
                            <p className="text-sm text-slate-600 dark:text-slate-400">Gere listas de materiais e quantidades diretamente dos seus modelos.</p>
                        </div>
                    </div>
                    <div className="flex flex-1 flex-col gap-4 rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 p-6">
                        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-[#137fec]/10 text-[#137fec]">
                            <Database className="text-3xl" />
                        </div>
                        <div className="flex flex-col gap-1">
                            <h3 className="text-lg font-bold text-slate-800 dark:text-white">Base de Custos em Tempo Real</h3>
                            <p className="text-sm text-slate-600 dark:text-slate-400">Acesse preços atualizados de materiais e mão de obra para orçamentos precisos.</p>
                        </div>
                    </div>
                    <div className="flex flex-1 flex-col gap-4 rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 p-6">
                        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-[#137fec]/10 text-[#137fec]">
                            <FileText className="text-3xl" />
                        </div>
                        <div className="flex flex-col gap-1">
                            <h3 className="text-lg font-bold text-slate-800 dark:text-white">Relatórios Colaborativos</h3>
                            <p className="text-sm text-slate-600 dark:text-slate-400">Gere e compartilhe relatórios abrangentes com sua equipe e stakeholders.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Recursos;
